<main>
  <app-loading-page></app-loading-page>
  <app-navbar
    *ngIf="isMobile"
    class="sticky top-0 z-10"
    (clickMenu)="showSideMenu = !showSideMenu"
  />
  <div class="flex w-full">
    <app-sidenavbar
      id="side-menu"
      class="side-menu"
      [showSideMenu]="showSideMenu"
      [ngClass]="!isMobile && showSideMenu ? 'basis-60' : 'basis-14'"
    />
    <div
      class="min-w-0 flex-1"
      [ngClass]="isMobile && showSideMenu ? 'brightness-50' : ''"
    >
      <app-navbar
        *ngIf="!isMobile"
        class="sticky top-0 z-10"
        (clickMenu)="showSideMenu = !showSideMenu"
      />
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-alert></app-alert>
</main>
